import React from "react";
import { styled } from "@mui/system";

// 2. Create a styled div that covers the screen and has the diagonal shape
const GradientDiv = styled("div")({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",       // Full screen
  zIndex: -1,           // Behind all content
  background: "hsl(var(--login-bg, 210 33% 20%))",
  // Clip only the top portion diagonally; tweak these coordinates as needed:
  clipPath: "polygon(0 0, 100% 0, 100% 50%, 0 35%)",
});

const StripyBackground: React.FC = () => {
  return <GradientDiv />;
};

export default StripyBackground;
